import gql from 'graphql-tag'

export const GET_USER_GROUP = gql`
  query Ugroups($filter: UgroupsFilter) {
    ugroups(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      ugroups {
        data {
          id
          companyId
          name
          mgroupId
          active
          hasRelation
          vgroups {
            id
            name
            totalVehicle
          }
        }
        pagination {
          page
          show
          total
        }
      }
    }
  }
`

export const GET_USER_GROUP_DETAIL = gql`
  query Ugroup($filter: GetUgroupInput!) {
    ugroup(filter: $filter) {
      isSuccessful
      message
      ugroup {
        id
        companyId
        name
        mgroupId
        vgroups {
          name
          id
        }
        hasRelation
      }
    }
  }
`

export const UPDATE_USER_GROUP = gql`
  mutation UpdateUgroup($input: UpdateUgroupInput!) {
    updateUgroup(input: $input) {
      isSuccessful
      message
    }
  }
`

export const CREATE_USER_GROUP = gql`
  mutation CreateUgroup($input: CreateUgroupInput!) {
    createUgroup(input: $input) {
      isSuccessful
      message
    }
  }
`

export const DELETE_USER_GROUP = gql`
  mutation DeleteUgroup($input: GetUgroupInput!) {
    deleteUgroup(input: $input) {
      isSuccessful
      message
    }
  }
`

export const GET_MGROUPS = gql`
  query Mgroups($filter: GetMgroupsFilter) {
    mgroups(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      mgroups {
        data {
          mgroupId
          companyId
          name
          hasRelation
        }
        pagination {
          total
          page
          show
        }
      }
    }
  }
`

export const GET_MGROUP = gql`
  query Mgroup($filter: GetMgroupFilter!) {
    mgroup(filter: $filter) {
      isSuccessful
      message
      mgroup {
        mgroupId
        companyId
        name
      }
    }
  }
`
